import React from "react";
require("../../assets/stylesheets/Utils/BackDecoration.css");

function BackDecoration() {
  return (
    <div className="circles">
      <div className="circle-1"></div>
      <div className="circle-2"></div>
      <div className="circle-3"></div>
      <div className="circle-4"></div>
    </div>
  );
}

export default BackDecoration;
